enum CensusUrlKeys {
  YEAR = "year",
  OUTPUT_AREA = "outputArea",
  CATEGORY = "category",
  COLUMN = "column",
}

export default CensusUrlKeys;
